// shipment views
const Shipment = () => import("Modules/manufacturing/shipment/views/Shipment");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "shipping",
            name: "shipment",
            component: Shipment,
            meta: {
                requiresAuth: true,
                title: "lang.shipment",
                restrict_by_login_type: ["employee"],
            },
        },
    ],
};
